import { render, staticRenderFns } from "./Kayttajat.vue?vue&type=template&id=5fcd19aa&"
import script from "./Kayttajat.vue?vue&type=script&lang=js&"
export * from "./Kayttajat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports